import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Extract initials from a name or email.
 * - "Jean Dupont" → "JD" (first + last name initials)
 * - "Jean Pierre Dupont" → "JD" (first + last name initials)
 * - "Jean" → "JE" (first 2 characters)
 * - Falls back to first 2 characters of email if no name
 */
export function getInitials(
  name?: string | null,
  email?: string | null,
): string {
  if (name) {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
      return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
    }
    if (parts.length === 1 && parts[0]!.length > 0) {
      return parts[0]!.substring(0, 2).toUpperCase();
    }
  }
  if (email) {
    return email.slice(0, 2).toUpperCase();
  }
  return "?";
}
